export default "__VITE_ASSET__BbxDWHID__"